import type { FieldMetaProps, FormikProps, FormikState } from 'formik';
import { map } from 'lodash';

export const shouldDisplayError = ({
  form,
  meta,
}: {
  form: Pick<FormikState<any>, 'submitCount'>;
  meta: Pick<FieldMetaProps<any>, 'error' | 'touched'>;
}): string | false | undefined =>
  (form.submitCount > 0 || meta.touched) && meta.error;

export const shouldConsiderFormValid = ({
  errors,
  isValid,
  submitCount,
  touched,
}: Pick<
  FormikProps<any>,
  'errors' | 'isValid' | 'submitCount' | 'touched'
>) => {
  const hasErrors = map(
    errors,
    (_, k) =>
      ({
        error: errors[k],
        touched: touched[k],
      }) as FieldMetaProps<any>,
  ).some((meta) => shouldDisplayError({ form: { submitCount }, meta }));

  return isValid && !hasErrors;
};

export default shouldDisplayError;
